const liveTomcatConfig = {
  statusBar: {
    visibility: true,
    messgae: "UnderDevelopmentStatusBand",
    color: "red"
  },
  backend: {
    url: "https://api.rebelskool.com/"
  },
  apps: {
    url: "https://apps.rebelskool.com/"
  },
  annualReport: {
    url: "https://apps.rebelskool.com/annualreport"
  },
  annualReportWithHash: {
    url: "https://apps.rebelskool.com/#/annualreport"
  },
  corporatePage: {
    url: "https://rebelskool.com/"
  },
  SRU: {
    url: "https://apps.rebelskool.com/income-declaration-2"
  },
  NE: {
    url: "https://apps.rebelskool.com/income-declaration-1"
  },
  forAccountingCompanies: {
    url: "https://apps.rebelskool.com/for-accounting-companies"
  },
  microsoftBusinessCentral: {
    url: "https://apps.rebelskool.com/microsoft-business-central-development"
  },
  ContactUs: {
    uploadFileSizeLimit: 2
  },
  Skatteverket: {
    environment: "liveEnvironment"
  }
};

export default liveTomcatConfig;
